<page-header title="VALUATION_AND_RATE_BOOK"></page-header>
<card>
  <button
    class="button is-info"
    [disabled]="isLoading"
    (click)="createReport()"
    [ngClass]="{ 'is-loading': isLoading }"
    translationEditableDirective="GENERATE_REPORT"
  >
    {{ 'GENERATE_REPORT' | translate }}
  </button>
</card>
